import { combineReducers } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useSelector } from "react-redux";

import {
  codeBookApi,
  committeeApi,
  founderApi,
  institutionApi,
  oibApi,
  remarkApi,
  requestApi,
  schoolCandidateApi,
} from "../queries";
import applicationReducer from "../slices/applicationSlice";

const rootReducer = combineReducers({
  application: applicationReducer,
  [codeBookApi.reducerPath]: codeBookApi.reducer,
  [committeeApi.reducerPath]: committeeApi.reducer,
  [remarkApi.reducerPath]: remarkApi.reducer,
  [institutionApi.reducerPath]: institutionApi.reducer,
  [founderApi.reducerPath]: founderApi.reducer,
  [oibApi.reducerPath]: oibApi.reducer,
  [requestApi.reducerPath]: requestApi.reducer,
  [schoolCandidateApi.reducerPath]: schoolCandidateApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

export default rootReducer;
